module.exports = __webpack_public_path__ + "static/img/banner2-2.f4670b2.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/banner2-2.jpg
// module id = jiU1
// module chunks = 1